import { render } from "./Login.vue?vue&type=template&id=3ff6c3a5&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3ff6c3a5"

export default script